// Set in index.html by vstatic when deployed via vstatic. Not present when developing locally
import { environment as angularSetEnvironment } from './environment';
import { environment as prodEnvironment } from './environment.prod';
import { BookMeNowEnvironment } from './interface';

declare let environment: string;

// A cached environment used to ensure environment is NOT changed after the first usage.
let ENVIRONMENT: BookMeNowEnvironment;

export function getEnvironment(): BookMeNowEnvironment {
  if (ENVIRONMENT) {
    return ENVIRONMENT;
  }

  // angularSetEnvironment is the environment the Angular configuration has chosen (the environment.ts file is overridden)
  let env = angularSetEnvironment.name;
  if (typeof environment !== 'undefined') {
    env = environment as 'DEMO' | 'PROD';
  }

  switch (env.toUpperCase()) {
    case 'DEMO':
      ENVIRONMENT = angularSetEnvironment;
      break;
    case 'PROD':
      ENVIRONMENT = prodEnvironment;
      break;
    default:
      ENVIRONMENT = angularSetEnvironment;
  }

  return ENVIRONMENT;
}
